export default function updateMapType(state, { mapType }) {
  return Object.assign({}, state, {
    map: {
      ...state.map,
      mapType
    }
  })
}



// WEBPACK FOOTER //
// ./src/reducers/updateMapType.js